const { LOCALES } = require('./locales');
const { GRAPHIC_DESIGN } = require('./videos');

const DEFAULT_LOCALE = LOCALES.EN;
const SPAINISH_LOCALE = LOCALES.ES;
const EXPLAINER_VIDEO = GRAPHIC_DESIGN;

module.exports = {
    DEFAULT_LOCALE,
    SPAINISH_LOCALE,
    EXPLAINER_VIDEO
};
